type UserWithEmails = {
	user?: {
		emails?: ReadonlyArray<
			| {
					value?: string | null;
			  }
			| null
			| undefined
		> | null;
	} | null;
};

/**
 * Is Atlassian Staff
 *
 * Given user query results containing the email field, returns
 * whether or not one of the user's registered emails ends with either
 * an atlassian user or test user domain.
 */
export const isAtlassianStaff = (data?: UserWithEmails) => {
	return (
		data?.user?.emails?.some(
			(email) =>
				email?.value &&
				(email.value.endsWith('@atlassian.com') ||
					email.value.endsWith('@atlassian.com.invalid') ||
					email.value.endsWith('@usersinbuckets.com')),
		) || false
	);
};
